import axios from "axios";
import { callAPI } from "./helper";
import { USER_LOGIN_SIGNUP_URL } from "./API_URL";

export function userRegistration(param) {
  const formData = new FormData();

  if (param.degreeUploadFile.length > 0) {
    param.degreeUploadFile.map((elm) => {
      formData.append("degreeFiles", elm);
    });
  }

  if (param.pastWorkFiles.length > 0) {
    param.pastWorkFiles.map((elm) => {
      formData.append("sampleWorkFiles", elm);
    });
  }

  formData.append("type", param.type);
  formData.append("first_name", param.first_name);
  formData.append("last_name", param.last_name);
  formData.append("email", param.email);
  formData.append("password", param.password);
  formData.append("country", JSON.stringify(param.country));
  formData.append("phone", param.phone);
  formData.append("highestDegree", JSON.stringify(param.highestDegree));
  formData.append("subject", JSON.stringify(param.subject));
  formData.append("outsourcedTasks", JSON.stringify(param.outsourcedTasks));
  formData.append("specialization", JSON.stringify(param.specialization));
  formData.append("writingExperience", JSON.stringify(param.writingExperience));
  formData.append("companyName", param.companyName);
  formData.append("wordCount", JSON.stringify(param.wordCount));
  formData.append("profilePic", param.profilePic);
  formData.append("bio", param.bio);
  formData.append("referralLink", param.referralLink ?? undefined);

  const headers = {
    "Content-Type": "multipart/form-data",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/userRegistration";
  return callAPI(headers, endpoint, "POST", formData);
}

export function userRegistrationShortened(param) {
  const formData = new FormData();
  formData.append("first_name", param.first_name);
  formData.append("last_name", param.last_name);
  formData.append("email", param.email);
  formData.append("country", JSON.stringify(param.country));
  formData.append("phone", param.phone);
  formData.append("password", param.password);
  formData.append("referralLink", param.referralLink ?? undefined);
  formData.append("utmLink", param.utmLink ?? "");

  const headers = {
    "Content-Type": "multipart/form-data",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/userRegistrationShort";
  return callAPI(headers, endpoint, "POST", formData);
}

export function googleSignup(param) {
  const formData = new FormData();
  formData.append("name", param.name);
  formData.append("email", param.email);
  // formData.append("imageUrl", param.imageUrl);
  formData.append("phone", param.phone);
  formData.append("phone_country_id", param.phoneCountryId);

  const headers = {
    "Content-Type": "multipart/form-data",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/google-user-login";
  return callAPI(headers, endpoint, "POST", formData);
}


export function userPassResetOTP(param) {
  const headers = {
    "Content-Type": "application/json",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/reset-password-otp";
  return callAPI(headers, endpoint, "POST", param);
}

export function checkSameOtp(param) {
  const headers = {
    "Content-Type": "application/json",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/check-same-otp";
  return callAPI(headers, endpoint, "POST", param);
}

export function updatePassword(param) {
  const headers = {
    "Content-Type": "application/json",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/updatePassword";
  return callAPI(headers, endpoint, "POST", param);
}

export function userPassReset(param) {
  const headers = {
    "Content-Type": "application/json",
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/reset-password";
  return callAPI(headers, endpoint, "POST", param);
}

export function sendOTP(param) {
  const formData = new FormData();
  formData.append("user_id", param.user_id);
  formData.append("mobile_number", param.mobile_number);
  formData.append("country_id", param.country_id);
  const headers = {
    // authorization: `Bearer ${accessToken}`
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/resendOTP";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, formData);
}

export function changeContactDetails(param) {
  const formData = new FormData();
  formData.append("user_id", param.user_id);
  formData.append("currEmail", param.currEmail);
  formData.append("currPhone", param.currPhone);
  formData.append("newPhone", param.newPhone);
  formData.append("newCountryCode", param.newCountryCode);
  formData.append("newEmail", param?.newEmail);
  formData.append("updateType", param?.updateType);
  const headers = {
    // authorization: `Bearer ${accessToken}`
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/handleContactChange";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, formData);
}

export function verifyOTP(param) {
  const formData = new FormData();
  formData.append("email", param.email);
  formData.append("mobile_number", param.mobile_number);
  formData.append("otp", param.otp);
  const headers = {
    // authorization: `Bearer ${accessToken}`
  };
  const endpoint = USER_LOGIN_SIGNUP_URL + "/otp-verification";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, formData);
}

export async function verifyEmail(param) {
  return await axios({
    url: USER_LOGIN_SIGNUP_URL + "/email-verification",
    method: "POST",
    headers: {
      // authorization: `Bearer ${accessToken}`,
    },
    data: param,
  })
    .then((response) => {
      if (response.data.code === 200) {
        return response.data;
      } else {
        return { error: true, code: 400, message: "Email verification failed" };
      }
    })
    .catch((error) => {
      return { error: true, code: 500, message: "Something went wrong, kindly try again..." };
    });
}

export async function sendVerificationEmail(param) {
  return await axios({
    url: USER_LOGIN_SIGNUP_URL + "/send-email-verification-code",
    method: "POST",
    headers: {
      // authorization: `Bearer ${accessToken}`,
    },
    data: param,
  })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return { error: true, code: 400, message: "Something went wrong, kindly try again..." };
      }
    })
    .catch((error) => {
      return { error: true, code: 500, message: "Something went wrong, kindly try again..." };
    });
}
